import { MessageType } from '@/data/enum'
import * as messages from '@/data/enum/message/messageTypes'
import { mapActions } from 'vuex'

const mixin = {
  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack',
      showMessageQueue: 'snackbar/showMessageQueue'
    }),

    showMessage (message) {
      this.showSnack(message)
    },

    showMessageByType (messageType) {
      this.showSnack(MessageType.messages[messageType].message)
    },

    handleErrorMessage (error) {
      if (!error.response || !error.response.data.full_messages) { this.showMessageByType(this.messageTypes.ERROR); return }

      switch (error.response.status) {
        case 422: {
          this.showMessageQueue(error.response.data.full_messages)
          break
        }

        default: {
          this.showMessageByType(this.messageTypes.ERROR)
          break
        }
      }
    }
  },

  computed: {
    messageTypes () {
      return messages
    }
  }
}

export default mixin
